export const gtagFuncCreator = (dataLayer) => {
  return (...args) => dataLayer.push(args)
}

export const injectScriptIntoDOM = (debugMode) => {
  (function (w, d, s, l, i) {
    w[l] = w[l] || []
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
    const f = d.getElementsByTagName(s)[0]
    const j = d.createElement(s)
    const dl = l !== 'dataLayer' ? `&l=${l}` : ''
    j.async = true
    j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`
    f.parentNode.insertBefore(j, f)
  }(window, document, 'script', 'dataLayer', 'GTM-PMZC62P'))

  const ga4Id = 'G-HJMZ53V9R3'

  const gtag = gtagFuncCreator(window.dataLayer)

  gtag('js', new Date())
  gtag('config', ga4Id, { debug_mode: debugMode })
}

export const loadGtm = (injectScript = injectScriptIntoDOM) => {
  window.dataLayer = window.dataLayer || []

  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  })

  if (!window.location.href.includes('ahaslides.eu') && params.tracking !== 'false') {
    let debugMode = true
    if (window.location.href.includes('ahaslides.com')) {
      debugMode = false
    }
    injectScript(debugMode)
  }
}
